export default {
  clean: () => import("/tmp/build_ea8f28b6/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_ea8f28b6/layouts/default.vue").then(m => m.default || m)
}